<template>
  <div>
    <div class="clearfix_" style="padding-top:0;" id="nationalDay">
      <div v-for="(item,index) in allData" :key="index">
        <div v-if="item.parentName=='nationalDay_banner'" class="nationalDay_banner" id="nationalDay_banner">
          <img src="http://img.source.9188cn.com/nationalDayBanner.jpg">
          <div class="nationalDay_banner_title">{{item.title}}</div>
        </div>
      </div>
      <div class="nationalDay_content">
          <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='nationalDay_recommend'">
            <div v-if="item.content!==undefined&&item.content!==null&&item.content.length>0" id="nationalDay_recommend" class="nationalDay_recommend">
                <div class="nationalDay_recommend_list clearfix_">
                    <div @click="goto(val)" v-for="(val,idx) in item.content" :key="idx" class="nationalDay_recommend_item fl">
                        <img class="nationalDay_recommend_item_bg" src="http://img.source.9188cn.com/nationalDay_recommend_item_bg.png">
                        <img class="nationalDay_recommend_item_img" :src="val.pic?val.pic:noImg">
                    </div>
                </div>
              </div>
          </div>
          <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='nationalDay_goods1'||item.parentName=='nationalDay_goods1_copy1'||item.parentName=='nationalDay_goods1_copy2'">
            <div v-if="item.goods!==undefined&&item.goods!==null&&item.goods.length>0" id="nationalDay_goods1" class="nationalDay_goods1">
                <div class="nationalDay_goods1_title">
                    <div class="nationalDay_goods1_title_txt">{{item.title}}</div>
                </div>
                <div class="nationalDay_goods1_list">
                    <div @click="gotoGoodsDetail(val)" v-for="(val,idx) in item.goods" :key="idx" class="nationalDay_goods1_list_item clearfix_">
                        <div class="fl nationalDay_goods1_list_item_txt">
                            <div class="nationalDay_goods1_list_item_name1">{{val.name}}</div>
                            <div class="nationalDay_goods1_list_item_name2">{{val.goodsSellPoint}}</div>
                            <div class="nationalDay_goods1_list_item_box clearfix_">
                                <div class="fl clearfix_ nationalDay_goods1_list_item_price_txt">
                                    <div class="fl">
                                        <div class="nationalDay_goods1_list_item_price_txt1">活动价</div>
                                        <div class="nationalDay_goods1_list_item_price_txt2">¥</div>
                                    </div>
                                    <div class="fl nationalDay_goods1_list_item_price">{{val.beforePrice}}<span>{{val.afterPrice}}</span></div>
                                </div>
                            </div>
                            <div class="nationalDay_goods1_list_item_btn">立即购买</div>
                        </div>
                        <div class="fr nationalDay_goods1_list_item_img"><img :src="val.pic?val.pic:noImg"></div>
                        <div class="nationalDay_goods1_list_item_doll"></div>
                    </div>
                </div>
              </div>
          </div>
          <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='nationalDay_goods2'||item.parentName=='nationalDay_goods2_copy1'||item.parentName=='nationalDay_goods2_copy2'">
            <div v-if="item.goods!==undefined&&item.goods!==null&&item.goods.length>0" id="nationalDay_goods2" class="nationalDay_goods1">
              <div class="nationalDay_goods1_title">
                  <div class="nationalDay_goods1_title_txt">{{item.title}}</div>
              </div>
              <div class="nationalDay_goods1_list">
                  <div @click="gotoGoodsDetail(val)" v-for="(val,idx) in item.goods" :key="idx" class="nationalDay_goods1_list_item nationalDay_goods2_list_item clearfix_">
                    <div class="fl nationalDay_goods1_list_item_img"><img :src="val.pic?val.pic:noImg"></div>
                    <div class="nationalDay_goods1_list_item_doll"></div>
                    <div class="fr nationalDay_goods1_list_item_txt">
                        <div class="nationalDay_goods1_list_item_name1">{{val.name}}</div>
                        <div class="nationalDay_goods1_list_item_name2">{{val.goodsSellPoint}}</div>
                        <div class="nationalDay_goods1_list_item_box clearfix_">
                            <div class="fl clearfix_ nationalDay_goods1_list_item_price_txt">
                                <div class="fl">
                                    <div class="nationalDay_goods1_list_item_price_txt1">活动价</div>
                                    <div class="nationalDay_goods1_list_item_price_txt2">¥</div>
                                </div>
                                <div class="fl nationalDay_goods1_list_item_price">{{val.beforePrice}}<span>{{val.afterPrice}}</span></div>
                            </div>
                        </div>
                        <div class="nationalDay_goods1_list_item_btn">立即购买</div>
                    </div>
                </div>
              </div>
            </div>
          </div>
          <div v-for="(item,index) in allData" :key="index" v-if="item.parentName=='nationalDay_goods3'||item.parentName=='nationalDay_goods3_copy1'||item.parentName=='nationalDay_goods3_copy2'">
            <div v-if="item.goods!==undefined&&item.goods!==null&&item.goods.length>0" id="nationalDay_goods3" class="nationalDay_goods3">
              <div class="nationalDay_goods1_title">
                  <div class="nationalDay_goods1_title_txt">{{item.title}}</div>
              </div>
              <div class="nationalDay_goods3_list">
                  <div class="nationalDay_goods3_list_box1">
                      <div class="nationalDay_goods3_list_box2 clearfix_">
                            <div @click="gotoGoodsDetail(val)" v-for="(val,idx) in item.goods" :key="idx" class="nationalDay_goods3_item fl">
                                <div class="nationalDay_goods3_item_doll_img"><img src="http://img.source.9188cn.com/nationalDay_goods3_item_doll.png"></div>
                                <div class="nationalDay_goods3_item_img"><img :src="val.pic?val.pic:noImg"></div>
                                <div class="nationalDay_goods3_item_name1">{{val.name}}</div>
                                <div class="nationalDay_goods3_item_name2">{{val.goodsSellPoint}}</div>
                                <div class="nationalDay_goods1_list_item_box nationalDay_goods3_list_item_box clearfix_">
                                    <div class="fl clearfix_ nationalDay_goods1_list_item_price_txt">
                                        <div class="fl">
                                            <div class="nationalDay_goods1_list_item_price_txt1">活动价</div>
                                            <div class="nationalDay_goods1_list_item_price_txt2">¥</div>
                                        </div>
                                        <div class="fl nationalDay_goods3_list_item_price">{{val.beforePrice}}<span>{{val.afterPrice}}</span></div>
                                    </div>
                                    <div class="fl nationalDay_goods3_list_item_btn">立即购买</div>
                                </div>
                            </div>
                      </div>
                  </div>
              </div>
            </div>
          </div>
      </div>
  </div>
  </div>
</template>

<script>
import axios from 'axios'
import Qs from 'qs'
import { ip,overtime } from '../../assets/js/public.js'
export default {
  data(){
    return {
      allData:[],
      noImg:require("@/assets/img/aa.png")
    }
  },
  mounted:function(){
    this.getProject()
  },
  methods:{
    gotoGoodsDetail:function(obj){
			var t_=this
			var href=t_.$router.resolve({name:'goodsdetails',query:{goodsId:obj.id,isSupplyChainGoods:2,supplyChainTenantId:obj.supplyChainTenantId}})
			window.open(href.href,'_blank')
    },
    goto:function(obj){
			var t_ = this
			if( obj.status==1 ){
                if(obj.atriceId=='')return
				var href=this.$router.resolve({
					name:'articleList',
					query:{
						id:obj.atriceId
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==2){
				var d = obj.categoryId
				var href=this.$router.resolve({
					name:'goodslist',
					query: {
						id: d
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==3){
				var d = obj.search
				var href=this.$router.resolve({
					name:'goodslist',
					query: {
						txt: d
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==5){
				window.open(obj.link)
			}else if(obj.status==6){
				var href=t_.$router.resolve({
					name:'goodsdetails',
					query:{
						goodsId:obj.goodsId,
						isSupplyChainGoods:2,
						supplyChainTenantId:obj.supplyChainTenantId
					}
				})
				window.open(href.href,'_blank')
			}else if(obj.status==9){
				if(obj.module==1){
					var href=this.$router.resolve({name:'teamGoods'});
					window.open(href.href,'_blank')
				}else if(obj.module==3){
					var href=this.$router.resolve({name:'couponList'});
					window.open(href.href,'_blank')
				}else if(obj.module==5){
					var href=this.$router.resolve({name:'activityList'});
					window.open(href.href,'_blank')
				}else if(obj.module==6){
					var href=this.$router.resolve({name:'scoreChange'});
					window.open(href.href,'_blank')
				}
			}
    },
    getProject:function(){
      var t_=this
      let data = Qs.stringify({
        channel:2,
        id:this.$route.query.id,
        tamp:localStorage.tamp?localStorage.tamp:''
      });
      axios.post(`${ip}formWorkInterface/getProject`, data).then(res=>{
        if(overtime(res.data.code)){
          localStorage.removeItem('tamp')
          localStorage.removeItem('name')
          return this.$router.push({
            path: '/LoginHome?state=1',
            query: {redirect: this.$route.fullPath,oldRoter:this.$route.path,oldData:this.$route.query}
          });
          this.$router.go(0);
        }
        if(res.data.code==300){
          var href=this.$router.resolve({name:'err404',query:{txt:res.data.message}})
          return window.open(href.href,'_blank')
        }
        if(res.data.code==0){
        t_.allData=res.data.results
        }else{
          return this.$router.push({path: '/'})
        }
      })
    }
  }
}
</script>
<style scoped>
#nationalDay{
    background: #ab0207;
    padding-top: 10px;
}
.nationalDay_banner{
    width: 100%;
    position: relative;
    margin-bottom: 36px;
}
.nationalDay_banner img{
    width: 100%;
}
.nationalDay_banner_title{
    position: absolute;
    left: 50%;
    height: 36px;
    color: #ffed97;
    top: 382px;
    width: 264px;
    margin-left: -132px;
    font-size: 20px;
    line-height: 34px;
    text-align: center;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.nationalDay_recommend{
    width: 800px;
    height: 185px;
    margin: 0 auto;
    margin-bottom: 36px;
    position: relative;
}
.nationalDay_recommend_item{
    width: 250px;
    height: 185px;
    margin-right: 25px;
    position: relative;
}
.nationalDay_recommend_item:last-child{
    margin-right: 0;
}
.nationalDay_recommend_item_bg{
    width: 250px;
    height: 185px;
    position: absolute;
    top: 0;
    left: 0;
    z-index: 2;
}
.nationalDay_goods1{
    width: 800px;
    margin: 0 auto;
    position: relative;
}
.nationalDay_goods1_title{
    background: url(http://img.source.9188cn.com/nationalDay_goods1_title.png);
    background-size: 100%;
    width: 640px;
    height: 103px;
    margin: 0 auto;
    position: relative;
    margin-bottom: 50px;
}
.nationalDay_goods1_title_txt{
    width: 220px;
    height: 48px;
    position: absolute;
    top: 46px;
    left: 50%;
    margin-left: -110px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 31px;
    color: #ffed97;
    line-height: 48px;
    text-align: center;
}
.nationalDay_goods1_list_item{
    width: 740px;
    height: 297px;
    background: url(http://img.source.9188cn.com/nationalDay_goods1_item_bg.png);
    background-size: 100%;
    padding: 40px 30px 40px 30px;
    margin-bottom: 40px;
    position: relative;
}
.nationalDay_goods1_list_item_txt{
    width: 410px;
    margin-top: 25px;
}
.nationalDay_goods1_list_item_name1{
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 32px;
    color: #feee99;
    margin-bottom: 30px;
}
.nationalDay_goods1_list_item_name2{
    width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 26px;
    color: #feee99;
    border-bottom: 1px dashed #feee99;
    margin-bottom: 30px;
    height: 46px;
}
.nationalDay_goods1_list_item_box{
    margin-bottom: 20px;
}
.nationalDay_goods1_list_item_price_txt{
    margin-right: 20px;
}
.nationalDay_goods1_list_item_price_txt1{
    font-size: 18px;
    color: #feee99;
    margin-bottom: 4px;
}
.nationalDay_goods1_list_item_price_txt2{
    font-size: 22px;
    color: #feee99;
    text-align: right;
}
.nationalDay_goods1_list_item_price{
    margin-top: -6px;
    margin-left: 5px;
    font-size: 52px;
    color: #feee99;
    width: 170px;
    overflow: hidden;
    text-overflow:ellipsis;
    white-space: nowrap;
}
.nationalDay_goods1_list_item_price span{
    font-size: 22px;
}
.nationalDay_goods1_list_item_btn{
    width: 150px;
    height: 34px;
    background: #feee99;
    line-height: 34px;
    text-align: center;
    color: #ab0205;
    font-size: 22px;
    border-radius: 15px;
    margin-top: 4px;
    float: right;
}
.nationalDay_goods1_list_item_img{
    width: 297px;
    height: 297px;
    background: #fff;
}
.nationalDay_goods1_list_item_img img{
    width: 297px;
    height: 297px;
}
.nationalDay_goods1_list_item_doll{
    width: 75px;
    height: 75px;
    position: absolute;
    top: 38px;
    right: 35px;
    background: url(http://img.source.9188cn.com/nationalDay_goods1_bg.png);
    background-size: 100%;
}
.nationalDay_goods2_list_item .nationalDay_goods1_list_item_doll{
    right: 0;
    left: 35px;
}
.nationalDay_goods3{
    position: relative;
    width: 800px;
    margin: 0 auto;
    margin-bottom: 50px;
}
.nationalDay_goods3_list{
    width: 760px;
    padding: 20px;
    margin: 0 auto;
    background: rgba(0,0,0,.05);
    border-radius: 50px;
}
.nationalDay_goods3_list_box1{
    width: 700px;
    background: #fef4d1;
    margin: 0 auto;
    border-radius: 50px;
    padding: 30px;
}
.nationalDay_goods3_list_box2{
    width: 700px;
    border-radius: 50px;
    margin: 0 auto;
}
.nationalDay_goods3_item{
    width: 340px;
    background: #ab0207;
    margin-right: 20px;
    margin-bottom: 20px;
    border-radius: 50px;
    overflow: hidden;
}
.nationalDay_goods3_item:nth-child(3),.nationalDay_goods3_item:nth-child(4){
    margin-bottom: 0;
}
.nationalDay_goods3_item:nth-child(2n){
    margin-right: 0;
}
.nationalDay_goods3_item_img{
    width: 340px;
    height: 340px;
    background: #ab0207;
    border-radius: 50px 50px 0 0;
    margin-bottom: 10px;
}
.nationalDay_goods3_item_img img{
    width: 340px;
    height: 340px;
}
.nationalDay_goods3_item_name1{
    padding: 0 20px;
    font-size: 29px;
    text-align: center;
    color: #fdee99;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 10px;
}
.nationalDay_goods3_item_name2{
    width: 300px;
    margin: 0 auto;
    font-size: 22px;
    height: 30px;
    color: #fdee99;
    text-align: center;
    border-bottom: 1px dashed #fdee99;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    margin-bottom: 20px;
}
.nationalDay_goods3_list_item_box{
    width: 300px;
    margin: 0 auto;
}
.nationalDay_goods3_item{
    position: relative;
}
.nationalDay_goods3_item_doll_img{
    width: 65px;
    height: 59px;
    position: absolute;
    top: 10px;
    right: 22px;
}
.nationalDay_goods3_item_doll_img img{
    width: 65px;
    height: 59px;
}
.nationalDay_content{
    background: url("http://img.source.9188cn.com/nationalDay_doll.png") repeat-y;
    background-size: 100%;
}
.nationalDay_recommend_item_img{
    width: 250px;
    height: 185px;
}
.nationalDay_goods3_list_item_price{
    margin-top: -6px;
    margin-left: 5px;
    font-size: 52px;
    color: #feee99;
    width: 220px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.nationalDay_goods3_list_item_price span{
    font-size: 22px;
}
.nationalDay_goods3_list_item_btn{
    width: 150px;
    height: 34px;
    line-height: 34px;
    text-align: center;
    color: rgb(171, 2, 5);
    font-size: 22px;
    margin-top: 4px;
    float: left;
    background: rgb(254, 238, 153);
    border-radius: 15px;
    margin-left: 75px;
    margin-bottom: 15px;
}
</style>



// WEBPACK FOOTER //
// src/components/nationalDay/nationalDay.vue